import { Box, Grid, Link } from "@mui/material";
import { Facebook, Instagram, YouTube } from "@mui/icons-material";
import { getBrandAssets } from "../../utils/assetHelpers";
import { useBrand } from "../../context/BrandContext";

// assets depend on brand slug
const IconLinks = () => {
  const { config } = useBrand();
  const assets = getBrandAssets(config?.brand?.slug);
  const { social } = config;

  if (!social) return null;

  return (
    <Grid
      container
      sx={{
        p: "calc(5px + 1vmin)",
        flexGrow: 1,
        gap: "0.5rem",
        maxWidth: "20rem",
        width: "100%",
        minHeight: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* First icon - Mixcloud for DJ Rise, SoundCloud for Rise DJ */}
      <Grid item xs={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center" },
            fontSize: "calc(10px + 1vmin)",
            mb: { xs: 1 },
          }}
        >
          {social.mixcloud && (
            <Link
              href={social.mixcloud.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#FFF",
                textDecoration: "none",
              }}
            >
              <Box
                component="img"
                src={assets.mixcloudSvg}
                alt="Mixcloud"
                sx={{ width: "auto", height: "calc(1rem + 4vmin)" }}
              />
            </Link>
          )}
          {social.soundcloud && (
            <Link
              href={social.soundcloud.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#FFF",
                textDecoration: "none",
              }}
            >
              <Box
                component="img"
                src={assets.soundCloudSvg}
                alt="SoundCloud"
                sx={{ width: "auto", height: "calc(1rem + 4vmin)" }}
              />
            </Link>
          )}
        </Box>
      </Grid>

      {/* Facebook */}
      <Grid item xs={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center" },
            fontSize: "calc(10px + 1vmin)",
            mb: { xs: 1 },
          }}
        >
          <Link
            href={social.facebook.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFF",
              textDecoration: "none",
            }}
          >
            <Facebook sx={{ width: "auto", height: "calc(1rem + 3vmin)" }} />
          </Link>
        </Box>
      </Grid>

      {/* Instagram */}
      <Grid item xs={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center" },
            fontSize: "calc(10px + 1vmin)",
            mb: { xs: 1 },
          }}
        >
          <Link
            href={social.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFF",
              textDecoration: "none",
            }}
          >
            <Instagram sx={{ width: "auto", height: "calc(1rem + 3vmin)" }} />
          </Link>
        </Box>
      </Grid>

      {/* YouTube */}
      <Grid item xs={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center" },
            fontSize: "calc(10px + 1vmin)",
            mb: { xs: 1 },
          }}
        >
          <Link
            href={social.youtube.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: "#FFF",
              textDecoration: "none",
            }}
          >
            <YouTube sx={{ width: "auto", height: "calc(1.7rem + 3vmin)" }} />
          </Link>
        </Box>
      </Grid>
    </Grid>
  );
};

export default IconLinks;
